import * as React  from 'react';
import '../../inCss/Card.css';

export interface CardProps {
    btnElement: string;
    clickEvt: () => void;
} 

export const Card: React.StatelessComponent<CardProps> = (props) => {

    return (
        <div className="card">
            <div className="card-body">
                <p id="pageTitle" className="card-title">Need help with your eSIM?</p>
                <p className="body-text" id="trbins">                
                Our troubleshooting tool can fix some of the most common eSIM problems. 
                Sign in below to get started.</p>                
                <p className="body-text">
                Or for more tips, 
                <a href="https://www.telstra.com.au/support/category/mobiles-tablets/other/esim-faqs?ti=TR:TR:11022019:esim:support:link:pos1:unauth" target="_blank" id="faq"> visit our FAQs</a>.  
                </p>
                <button id="btn_signin" className="button-primary btn-text" onClick={props.clickEvt}>
                    {props.btnElement}
                </button>
            </div>            
        </div>
    );
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/cards/Card.tsx